import React, {useEffect, useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Helmet, HelmetProvider} from "react-helmet-async";
import styled from "styled-components";
import ListComponent from "../../components/ListComponent";
import {apiEndPoints} from "../../api/network/apiEndPoints";
import {useDispatch, useSelector} from "react-redux";
import {ApiParam} from "../../api/network/apiParams";
import {fetchArch} from "../../api/redux/arch";
import {useLocation} from "react-router-dom";
import {useSearch} from "../../components/context/SearchContext";

const Typology = () => {
    const dispatch = useDispatch();
    const location = useLocation(); // Get the location object
    const {query, setQuery} = useSearch();

    // Parse query parameter from the URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlQuery = params.get("query");
        if (urlQuery) {
            setQuery(urlQuery); // Set query from URL
        }
    }, [location.search]);

    // API call
    useEffect(() => {
        const api_url = apiEndPoints.GET_ALL_PRODUCTS;
        const api_params = {
            [ApiParam.IMAGE]: "no",
            [ApiParam.POST]: "yes",
        };

        dispatch(fetchArch([api_url, api_params]));
    }, [dispatch]);

    const getPost = useSelector(state => state.arch);
    const data = getPost?.posts?.data;

    const filteredItems = data?.filter(item => {
        const productData = item?.product_data;

        // Safely check and convert each field to a string before calling `toLowerCase`
        return (
            productData?.title?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.general_location?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.type?.toLowerCase()?.includes(query.toLowerCase()) ||
            String(productData?.latitude).toLowerCase()?.includes(query.toLowerCase()) ||
            String(productData?.longitude).toLowerCase()?.includes(query.toLowerCase()) ||
            String(productData?.height).toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.owner?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.owner_profession?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.design_construction_period?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.structural_engineer?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.if_any?.toLowerCase()?.includes(query.toLowerCase()) ||
            String(productData?.project_cost).toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.typology?.toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.scale?.toLowerCase()?.includes(query.toLowerCase()) ||
            String(productData?.year).toLowerCase()?.includes(query.toLowerCase()) ||
            productData?.address?.toLowerCase()?.includes(query.toLowerCase())
        );
    });


    return (
        <HelmetProvider>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Architech Shamsul Wares | Architecture</title>
                <meta
                    name="Architech Shamsul Wares"
                    content="Our current mode and depiction of existence become almost incomprehensible due to the explosion of unimaginable visual."
                />
            </Helmet>
            <StyledComponent>
                <Container>
                    <Row key={0}>
                        <Col lg={12}>
                            {Array.isArray(filteredItems) && filteredItems.length > 0 ? (
                                filteredItems.map((item, index) => (
                                    <ListComponent
                                        key={index}
                                        category={item?.category}
                                        url={'architecture'}
                                        data={item}
                                    />
                                ))
                            ) : (
                                <p>Loading....</p>
                            )}
                        </Col>
                    </Row>
                </Container>
            </StyledComponent>
        </HelmetProvider>
    );
};

const StyledComponent = styled.section`
    .category {
        margin-bottom: 30px;

        h5 {
            font-size: 16px;
            font-weight: bold;
            line-height: 18px;
        }
    }
`;

export default Typology;
